'use client';
import React, { PureComponent, ReactNode } from 'react';
import PropTypes from 'prop-types';
import * as theme from './theme/index';

/**
 * Injects the theme and other platform config into all components
 */
export class ConfigContext extends PureComponent {
  static childContextTypes = {
    /** Theme object only used by Logo and Offer Card components to pull image URLs, should remove */
    theme: PropTypes.object,
    core: PropTypes.object,
    environment: PropTypes.object,
    functions: PropTypes.object,
  };

  static propTypes = {
    routerLink: PropTypes.func,
    browserHistory: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    environment: PropTypes.object,
    functions: PropTypes.object,
  };

  static defaultProps = {
    environment: {},
    functions: {},
    browserHistory: { push: (url) => console.info(url) },
  };

  getChildContext() {
    return {
      ...this.context,
      theme,
      environment: this.props.environment,
      core: {
        RouterLink: this.props.routerLink,
        browserHistory: this.props.browserHistory,
      },
      functions: this.props.functions,
    };
  }

  render() {
    return (
      <div className="dsgc-ns" id="tooltip-root">
        {this.props.children}
      </div>
    );
  }
}

export type ConfigContextTypes = {
  environment: Object;
  functions: Object;
  core: {
    RouterLink: ReactNode;
    browserHistory: Function | Object;
  };
};
